import { consola } from "consola";
export const logger = consola.withTag("nuxt-multi-cache");
